import React from "react";
import {ReactComponent as Logo} from '../../assets/svgs/logo.svg';
import FileFlatButton from "../buttons/file_flat_button";

function UploadContentBlock() {
    return (
        <div className={"w-80 h-80 bg-gray-100 shadow-lg rounded-lg"}>
            <div className={"w-80 h-5/6 bg-white flex flex-col justify-around items-center p-12 rounded-t-lg"}>
                <Logo/>
                <FileFlatButton name="Upload image/video"/>
                <p className={"text-xs"}>or drop it anywhere on the screen</p>
            </div>
            <p className={"text-xs text-center my-4"}>
                Paste video/image or URL
            </p>
        </div>
    );
}

export default UploadContentBlock;